import { render, staticRenderFns } from "./FilterCardPagination.vue?vue&type=template&id=3e625fa7"
import script from "./FilterCardPagination.vue?vue&type=script&lang=ts"
export * from "./FilterCardPagination.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports